import React,{Component} from 'react';

class AppBarDashboard extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div>
                <div>
                    {this.props.children}
                </div>
            </div>
        );
    }
}

export default AppBarDashboard;
